export const TASK_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

export const TASK_PRIORITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  URGENT: 'urgent'
};

export const TASK_STATUS_LABELS = {
  [TASK_STATUS.PENDING]: 'Pendiente',
  [TASK_STATUS.IN_PROGRESS]: 'En progreso',
  [TASK_STATUS.COMPLETED]: 'Completada',
  [TASK_STATUS.CANCELLED]: 'Cancelada'
};

export const TASK_PRIORITY_LABELS = {
  [TASK_PRIORITY.LOW]: 'Baja',
  [TASK_PRIORITY.MEDIUM]: 'Media',
  [TASK_PRIORITY.HIGH]: 'Alta',
  [TASK_PRIORITY.URGENT]: 'Urgente'
};

export const TASK_STATUS_COLORS = {
  [TASK_STATUS.PENDING]: '#ed6c02',
  [TASK_STATUS.IN_PROGRESS]: '#1976d2',
  [TASK_STATUS.COMPLETED]: '#2e7d32',
  [TASK_STATUS.CANCELLED]: '#757575'
};

export const TASK_PRIORITY_COLORS = {
  [TASK_PRIORITY.LOW]: '#757575',
  [TASK_PRIORITY.MEDIUM]: '#1976d2',
  [TASK_PRIORITY.HIGH]: '#ed6c02',
  [TASK_PRIORITY.URGENT]: '#d32f2f'
};

export const createTaskItem = () => ({
  title: '',
  description: '',
  status: TASK_STATUS.PENDING,
  priority: TASK_PRIORITY.MEDIUM,
  assignedTo: [],
  assignedToNames: [], 
  assignedBy: null,
  assignedByName: '',
  dueDate: null, // Ahora incluirá fecha y hora
  completedAt: null,
  tags: [],
  files: [],
  relatedTo: {
    type: null,
    id: null,
    name: ''
  },
  comments: [],
  isActive: true,
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
});